import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const wrap: CSSObject = {
  margin: '12px 0 20px',
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.35,
  letterSpacing: '-0.02em',
  color: theme.color.text,
  [mobile]: {
    margin: '20px 0 16px',
    fontSize: 20,
  },
};

export { wrap };
